import { ReactElement } from 'react';

import { PrintTemplateUnmarkAsFavoriteCommand } from '@dreryk/egabinet-document-template-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import {
   dispatchSnackbarPositiveEvent,
   HeartIcon,
   IconFillColor,
   IconWrapper,
   Tooltip,
} from '@dreryk/react-components';

import { consentTemplateActionTranslationKeys } from '../../../../../../translations';

const t = consentTemplateActionTranslationKeys.modal.form.table.options.unmarkAsFavorite;

type ConsentTemplateUnmarkAsFavoriteIconProps = {
   readonly printTemplateId: number;
   readonly onUnmarkedAsFavorite: VoidFunction;
};

export const ConsentTemplateUnmarkAsFavoriteIcon = (props: ConsentTemplateUnmarkAsFavoriteIconProps): ReactElement => {
   const { executeAsync: unmarkAsFavorite } = useCqrsCommand<void, unknown>(
      () => {
         const command = new PrintTemplateUnmarkAsFavoriteCommand();
         command.id = props.printTemplateId;
         return command;
      },
      {
         onSuccess: () => {
            props.onUnmarkedAsFavorite();
            dispatchSnackbarPositiveEvent(t.successMessage);
         },
      }
   );

   return (
      <Tooltip testId={'unmarkAsFavorite'} content={t.tooltipMessage}>
         <IconWrapper onClick={unmarkAsFavorite} testId={'unmarkAsFavorite'} fillColor={IconFillColor.PRIMARY}>
            <HeartIcon />
         </IconWrapper>
      </Tooltip>
   );
};
